<template>
  <div class="index">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">

        <!-- Page Content -->
        <div class="content container-fluid">

          <!-- Page Header -->
          <div class="page-header">
            <div class="row">
              <div class="col-sm-12">
                <h3 class="page-title">Welcome, {{employee.firstName}}!</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item active">Dashboard</li>
                </ul>
              </div>
            </div>
          </div>
          <!-- /Page Header -->

           <div class="card mb-0">
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="profile-view">
                    <div class="profile-img-wrap">
                      <div class="profile-img">
                        <a
                          ><img alt="" :src="media + employee.passportPhoto" v-if="employee.passportPhoto"
                        />
                        <img alt="" src="~@/assets/profiles/avatar-02.jpg" v-if="!employee.passportPhoto"
                        /></a>
                      </div>
                    </div>
                    <div class="profile-basic">
                      <div class="row">
                        <div class="col-md-5">
                          <div class="profile-info-left">
                            <h3 class="user-name m-t-0 mb-0">
                              {{ employee.firstName + " " + employee.lastName }}
                            </h3>
                            <h6 class="text-muted">{{employee.designation.name}}</h6>
                            <small class="text-muted">{{employee.designation.department.name}}</small>
                            <div class="staff-id">
                              Employee ID : {{ company.abbrv +'-' + employee.id }}
                            </div>
                            <div class="small doj text-muted">
                              Date of Join : {{ new Date(employee.createdAt).toLocaleDateString() }}
                            </div>
                            <!-- <div class="staff-msg">
                              <router-link to="/chat" class="btn btn-custom"
                                >Send Message
                              </router-link>
                            </div> -->
                          </div>
                        </div>
                        <div class="col-md-7">
                          <ul class="personal-info">
                            <li>
                              <div class="title-label">Phone:</div>
                              <div class="text">
                                {{ employee.phone }}
                              </div>
                            </li>
                            <li>
                              <div class="title-label">Email:</div>
                              <div class="text">
                                <a href="">{{ employee.email }}</a>
                              </div>
                            </li>
                            <li>
                              <div class="title-label">Birthday:</div>
                              <div class="text">{{ new Date(employee.birthday).toLocaleDateString() }}</div>
                            </li>
                            <li>
                              <div class="title-label">Address:</div>
                              <div class="text">{{ employee.address }}</div>
                            </li>
                            <li>
                              <div class="title-label">Gender:</div>
                              <div class="text">{{ employee.gender }}</div>
                            </li>
                            <li>
															<div class="title-label">Reports to:</div>
															<div class="text" v-if="employee.employeeManager">
																<div class="avatar-box">
																	<div class="avatar avatar-xs">
																		<img alt="" :src="media + employee.employeeManager.manager.passportPhoto" v-if="employee.employeeManager.manager.passportPhoto" />
                                    <img alt="" src="~@/assets/profiles/avatar-02.jpg" v-if="!employee.employeeManager.manager.passportPhoto" />
																	</div>
																</div>
																<router-link :to="{name: 'employeedetail', params: {id: employee.employeeManager.id}}">{{employee.employeeManager.manager.firstName + ' ' + employee.employeeManager.manager.lastName}}</router-link>
															</div>
														</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div class="pro-edit">
                      
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        <hr />
         <div
              id="emp_profile"
              class="pro-overview tab-pane fade show active"
            >
              <div class="row">

                <div class="col-md-6 d-flex">
                    <div class="col-md-12 d-flex">
                  <div class="card flex-fill">
                    <div class="card-body">
                      <h2 class="card-title col-md-12">
                        Welcome to {{company.name}}
                      </h2>
                      <br />
                      <br />
                      <br />
                      <br />
                      <div class="col-md-12" v-html="employee.onboarding.welcomeGuide">
                      </div>
                    </div>
                  </div>
                    </div>
                </div>


                <div class="row col-md-6 d-flex">
                  <div class="col-md-12 d-flex">
                    <div class="card profile-box flex-fill">
                      <div class="card-body">
                        <h3 class="card-title">
                          Activities
                        </h3>
                        <ul class="list-group list-group-flush">
                          <li class="list-group-item py-0 px-0" v-for="item in employee.employeeActivities" :key="item.id">
                            <div class="row align-items-center">
                            <div class="col-md-1">
                                <input v-model="item.status" @change="applyActivity($event, item)"
                                  type="checkbox" 
                                />
                            </div>
                            <div class="col-md-7">
                                {{item.activity.name}}
                            </div>

                            <div class="col-md-3">
                              {{new Date(item.dueDate).toLocaleDateString()}}
                            </div>
                        
                            <div class="col-md-1">
                              <label class="col-form-label">
                                  <div class="dropdown">
                                      <button class="dropdown-toggle" @click="toggle($event)"></button>
                                  </div>
                              </label>
                            </div>
                              
                          </div>
                          <div class="collapse">
                            <div class="card-body">
                            {{item.activity.description}}
                            </div>
                          </div>
                          </li>
                          
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12 d-flex">
                    <div class="card profile-box flex-fill">
                      <div class="card-body">
                        <h3 class="card-title">
                          Resources
                        </h3>
                        <ul class="list-group list-group-flush">
                          <li class="list-group-item py-0 px-0" v-for="item in employee.employeeResources" :key="item.id">
                            <div class="row align-items-center">
                            <div class="col-md-1">
                                <input v-model="item.status" @change="applyResource($event, item)"
                                  type="checkbox" 
                                />
                            </div>
                            <div class="col-md-10">
                                    {{item.resource.name}}
                                </div>
                                <div class="col-md-1">
                                <label class="col-form-label">
                                    <div class="dropdown">
                                        <button class="dropdown-toggle" @click="toggle($event)"></button>
                                    </div>
                                </label>
                                </div>
                              
                            </div>
                            <div class="collapse">
                              <div class="card-body">
                                <button type="button"  class="btn btn-secondary" v-if="item.resource.document" @click="getResourceDocument(item.resource.document, item)">Download Resource</button>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
            </div>

            <!-- <div class="row">
                <div class="col-md-6 d-flex">
                  <div class="card profile-box flex-fill">
                    <div class="card-body">
                      <h3 class="card-title">
                        
                        <div class="row align-items-center">
                          <div class="col-md-1">
                              <input 
                                type="checkbox" 
                              />
                          </div>
                      
                          <div class="col-md-7">
                              Activity Name
                          </div>

                          <div class="col-md-2">
                              Date
                          </div>
                      
                          <div class="col-md-2">
                            <label class="col-form-label">
                                <div class="dropdown edit-icon">
                                    <a class="dropdown-toggle" href="#" role="button" data-toggle="dropdown" aria-expanded="false"></a>
                                    <div class="dropdown-menu">
                                        <a class="dropdown-item" href="#">Action</a>
                                        <a class="dropdown-item" href="#">Another</a>
                                    </div>
                                </div>
                            </label>
                          </div>
                            
                        </div>
                      </h3>
                      <div class="card-title">
                        
                        <div class="row align-items-center">
                          <div class="col-md-1">
                              <input 
                                type="checkbox" 
                              />
                          </div>
                      
                          <div class="col-md-7">
                              Activity Name
                          </div>

                          <div class="col-md-2">
                              Date
                          </div>
                      
                          <div class="col-md-2">
                            <label class="col-form-label">
                                <div class="dropdown edit-icon">
                                    <a class="dropdown-toggle" href="#" role="button" data-toggle="dropdown" aria-expanded="false"></a>
                                    <div class="dropdown-menu">
                                        <a class="dropdown-item" href="#">Action</a>
                                        <a class="dropdown-item" href="#">Another</a>
                                    </div>
                                </div>
                            </label>
                          </div>
                            
                        </div>
                      </div>
                      <ul class="personal-info">
                          <div class="col-md-1"></div>
                          <div class="col-md-11">
                            <h3 class="title">Description </h3> 
                          </div>
                      </ul>
                    </div>
                  </div>
                </div>

              </div> -->
            </div>
      

        </div>
        <!-- /Page Content -->
      </div>
    </div>
    <!-- /Page Wrapper -->

  </div>
</template>
<script>
  import LayoutHeader from '@/components/layouts/Header.vue'
  import LayoutSidebar from '@/components/layouts/employeeSidebar.vue'
  import { employeeService } from "@/services/employeeService.js";
import { authenticationService } from "@/services/authenticationService";
import { organizationService } from "@/services/organizationService";

  export default {
    components: {
      LayoutHeader,
      LayoutSidebar
    },
    data() {
      return {
        media: 'data:image/jpeg;base64,',
        employee: {
        firstName: null,
        gender: "",
        id: authenticationService.currentUserValue.employee.id,
        lastName: "",
        maritalStatus: null,
        nationality: null,
        passportIdentificationNumber: null,
        passportPhoto: null,
        phone: "",
        religion: null,
        onboarding: {},
        employeeActivities: [],
        employeeResources: []
      },
      company: authenticationService.currentOfficeValue,
      currentUser: authenticationService.currentUserValue,
      }
    },
    mounted() {  
      this.getHire()
    },
    methods: {
      getResourceDocument(file, item) {
      organizationService.getPolicyDocument(file).then(
        (response) => {
          let blob = new Blob([response.data], { type: response.data.type });
          // For the processing of the IE browser, CreateObjectURL is not supported by some IE browser
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, response.fileName);
          } else {
            var downloadElement = document.createElement("a");
            var href = window.URL.createObjectURL(blob); // Create a download link
            downloadElement.href = href;
            downloadElement.download = response.fileName; // Download the file name
            document.body.appendChild(downloadElement);
            downloadElement.click(); // click to download
            document.body.removeChild(downloadElement); // Download complete removal element
            window.URL.revokeObjectURL(href); // Release Blob object
          }

          item.status = true
          this.applyResource(null, item);
        },
        (error) => {
          error = error;
        }
      );
    },
      applyActivity(event, item){
        console.log(item)
        employeeService.UpdateEmployeeActivity(item.id, item)
      },
      applyResource(event, item){
        console.log(item)
        employeeService.UpdateEmployeeResource(item.id, item)
      },
      toggle(event) {
        var e = event.target
        e.classList.toggle("active");
        var p = e.parentElement.parentElement.parentElement.parentElement;
        var content = p.nextElementSibling;
        if (content.style.display === "block") {
          content.style.display = "none";
        } else {
        content.style.display = "block";
        }
      },
      getHire() {
        employeeService.getHire(this.currentUser.employee.id)
        .then(
          p => {
            this.employee = p
          }
        )
      },
    },
    name: 'onboarddetails'
  }
</Script>


// WEBPACK FOOTER //
// src/components/employees/onboarddetails.vue